<template>
  <div class="PaidMemberRemovalFinish">
    <section-header heading="2" ja="有料会員解約完了" />
    <div class="description">
      {{ description }}
    </div>
    <normal-btn @click="onHome">トップへ戻る</normal-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from "../components/NormalBtn"

export default {
  name: "PaidMemberRemovalFinish",
  components: {
    SectionHeader,
    NormalBtn
  },
  data() {
    return {
      description: '有料会員を解約しました。\nダウンロードされている画像は引き続きご利用いただけます。'
    }
  },
  methods: {
    onHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.description {
  color: #373737;
  font-size: 12px;
  margin: 30px 30px 0;
}
</style>
